import { writable, get } from 'svelte/store';

const model = () => {
	let store = writable(window.reviewAndSignModel || {});

	async function saveModelAsync(url) {
		let data = get(store);
		//console.log("saveModelAsync", url, data);

		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json",
			},
			body: JSON.stringify(data)
		};

		let response = await fetch(`${url}`, options);
		if (!response.ok) {
			let data = await response.json();
			return { ...data };
		}

		return {
			success: true
		};
	}

	return {
		...store,
		saveModelAsync,
	};
}

export default model();
